// extracted by mini-css-extract-plugin
module.exports = {"basic":"styles_basic__3fxFc","subtitle":"styles_subtitle__1cRd7"};